import React, { useState } from "react";
import { InputField, SubmitButton, TextComponent } from "../../../components";
import styles from "./changePassword.module.css";
import { Col, Row, Switch } from "antd";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";

const changePasswordKey = (
  <svg
    className={styles.imgCont}
    viewBox="0 0 675 665"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M417.845 30.0229C418.165 29.956 418.488 29.9079 418.816 29.8785L529.472 18.0005C529.603 17.973 529.739 17.9642 529.874 17.9554L554.537 15.3203C554.899 15.2643 555.23 15.2537 555.584 15.258L555.565 15.2619C557.626 15.262 559.576 15.9524 561.187 17.0866C561.187 17.0866 561.191 17.1054 561.213 17.1203C561.213 17.1203 561.213 17.1202 561.236 17.1351C561.236 17.1351 561.236 17.1351 561.259 17.15C562.025 17.7156 562.721 18.4136 563.296 19.1956C563.3 19.2144 563.3 19.2144 563.3 19.2144L563.323 19.2292C564.212 20.4755 564.832 21.9351 565.054 23.5565L580.779 133.937C581.109 136.261 580.561 138.613 579.302 140.564L423.563 377.206C443.868 425.051 443.006 478.919 420.998 525.797C418.718 530.65 412.992 532.635 408.229 530.414C403.421 528.164 401.362 522.453 403.612 517.645C423.979 474.271 424.089 424.21 403.925 380.319C402.549 377.311 402.811 373.783 404.628 371.028L561.263 133.041L547.341 35.3908L536.421 36.56L368.89 292.881C367.478 295.041 367.016 297.61 367.539 300.11C368.063 302.61 369.533 304.755 371.674 306.171C375.971 308.98 382.155 307.684 384.964 303.387L519.733 97.2167C522.63 92.7833 528.589 91.535 533.023 94.4327C537.456 97.3304 538.704 103.289 535.807 107.723L401.038 313.893C392.36 327.171 374.445 330.923 361.168 322.245C354.738 318.059 350.324 311.605 348.741 304.048C347.166 296.529 348.61 288.809 352.812 282.356L511.743 39.2179L430.295 47.9598L435.268 99.7031C435.464 101.86 434.942 104.049 433.734 105.872L396.96 162.161C395.563 164.298 393.38 165.776 390.88 166.3L354.901 173.837L284.079 282.195C282.054 285.268 278.551 286.904 274.908 286.47C212.872 279.215 153.113 307 119.055 359.11C69.8274 434.452 91.068 535.847 166.391 585.078C234.075 629.316 325.207 616.878 378.334 556.221C381.85 552.207 387.911 551.821 391.883 555.325C395.873 558.826 396.279 564.883 392.778 568.874C333.309 636.726 231.485 650.58 155.866 601.156C71.6537 546.115 47.9244 432.84 102.958 348.589C139.929 292.023 203.892 260.983 271.158 266.79L340.955 160C342.352 157.863 344.535 156.386 347.035 155.862L383.014 148.325L415.761 98.197L410.195 40.3381C409.796 35.4374 413.127 31.0113 417.845 30.0229ZM199.961 446.986C216.804 443.458 234.99 446.339 250.51 456.451C265.538 466.274 275.842 481.363 279.524 498.939C283.21 516.534 279.825 534.472 270.006 549.519C249.707 580.478 207.984 589.257 176.957 569.011C145.961 548.719 137.219 506.988 157.465 475.962C167.6 460.457 183.118 450.514 199.961 446.986ZM240.004 472.525C217.837 458.037 188.009 464.305 173.535 486.449C159.066 508.613 165.315 538.445 187.459 552.918C209.668 567.418 239.477 561.153 253.928 538.994C268.402 516.85 262.153 487.018 240.004 472.525Z"
      fill="var(--primary-color)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M207.967 223.673C218.607 221.444 229.517 219.944 240.317 219.231C245.602 218.889 250.189 222.893 250.531 228.178C250.869 233.445 246.894 237.888 241.584 238.392C180.332 242.472 122.593 273.621 85.8239 323.002C82.691 327.249 76.6988 328.151 72.3794 324.955C68.1243 321.784 67.2598 315.784 70.4264 311.51C104.029 266.403 152.871 235.215 207.967 223.673ZM49.077 355.07C47.9896 349.879 51.3162 344.789 56.507 343.702C61.6979 342.614 66.7874 345.941 67.8748 351.132C68.9622 356.323 65.6357 361.412 60.4448 362.5C55.254 363.587 50.1644 360.26 49.077 355.07ZM412.847 592.829C411.759 587.638 415.086 582.549 420.277 581.462C425.467 580.374 430.557 583.701 431.644 588.891C432.732 594.082 429.405 599.172 424.214 600.259C419.024 601.347 413.934 598.02 412.847 592.829ZM471.873 370.56C470.234 366.017 465.499 363.458 460.894 364.422C460.442 364.517 460.018 364.645 459.579 364.796C454.582 366.608 452.006 372.112 453.814 377.09C457.188 386.45 459.943 396.136 461.995 405.929C472.867 457.83 463.972 511.477 436.95 556.992C434.234 561.544 435.742 567.429 440.294 570.145C444.805 572.85 450.712 571.357 453.447 566.801C482.941 517.158 492.653 458.61 480.792 401.991C478.56 391.333 475.555 380.738 471.873 370.56Z"
      fill="var(--primary-color)"
      fill-opacity="0.2"
    />
  </svg>
);

const ChangePassword = () => {
  const user = useSelector((state) => state.AuthReducer.user);

  const [notificationPerm, setNotificationPerm] = useState(
    user?.is_receive_notifications
  );
  const [password, setpassword] = useState();
  const [passwordVisible, setpasswordVisible] = useState(true);
  const [newpassword, setNewpassword] = useState();
  const [newPasswordVisible, setNewPasswordVisible] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState();
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(true);
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const handleChangeNotification = () => {
    dispatch(AuthMiddleware.onChangeNotification()).then((data) => {
      setNotificationPerm(!notificationPerm);
    });
  };
  const inputCols = (role === roles.client || role === roles.coHost) ? 24 : 12;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onPressSave = () => {
    if (!password || !newpassword || !confirmPassword) {
      dispatch(
        showAlert({
          title: "Update Password",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/.test(
        newpassword
      ) == false
    ) {
      dispatch(
        showAlert({
          title: "Update Password",
          message:
            "Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (newpassword !== confirmPassword) {
      dispatch(
        showAlert({
          title: "Update Password",
          message: "Confirm password does not match!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      let userdata = {
        old_password: password,
        new_password: newpassword,
        confirm_password: confirmPassword,
      };
      dispatch(AuthMiddleware.updatePassword(userdata))
        .then((response) => {
          navigate(-1);
          setpassword("");
          setNewpassword("");
          setConfirmPassword("");
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <div className={styles.mainContainer}>
      {role != roles.client || role != roles.coHost ? null : (
        <>
          <TextComponent
            textClass={styles.settingsHeading}
            text={"Notification Settings"}
          />
          <div className={styles.swithCont}>
            <TextComponent
              textClass={styles.notificationHeading}
              text={"Notifications"}
            />
            <Switch
              checked={notificationPerm}
              onClick={handleChangeNotification}
              // onChange={handleChangeNotification}
              className={styles.switchClass}
              style={{
                backgroundColor: notificationPerm && "var(--primary-color)",
              }}
            />
          </div>
        </>
      )}
      <Row className={styles.row}>
        <Col
          className={
            (role == roles.client || role == roles.coHost)  ? styles.leftCont : styles.leftContFull
          }
        >
          <TextComponent
            textClass={styles.textHeading}
            text={"Change Password"}
          />
          <Row gutter={[24, 16]}>
            <Col xs={24} lg={inputCols}>
              <InputField
                label={"Current Password"}
                placeholder={"••••••••••••••••"}
                value={password}
                onChange={(e) => setpassword(e.target.value)}
                rightIcon={
                  passwordVisible ? (
                    <BsEyeSlashFill color="var(--light-grey)" size={15} />
                  ) : (
                    <BsEyeFill color="var(--light-grey)" size={15} />
                  )
                }
                type={passwordVisible ? "password" : "text"}
                onRightIconPress={() => setpasswordVisible(!passwordVisible)}
              />
            </Col>
            <Col xs={24} lg={inputCols}>
              <InputField
                label={"Change Password"}
                placeholder={"••••••••••••••••"}
                value={newpassword}
                onChange={(e) => setNewpassword(e.target.value)}
                rightIcon={
                  newPasswordVisible ? (
                    <BsEyeSlashFill color="var(--light-grey)" size={15} />
                  ) : (
                    <BsEyeFill color="var(--light-grey)" size={15} />
                  )
                }
                type={newPasswordVisible ? "password" : "text"}
                onRightIconPress={() =>
                  setNewPasswordVisible(!newPasswordVisible)
                }
              />
            </Col>
            <Col xs={24} lg={inputCols}>
              <InputField
                label={"Confirm Password"}
                placeholder={"••••••••••••••••"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                rightIcon={
                  confirmPasswordVisible ? (
                    <BsEyeSlashFill color="var(--light-grey)" size={15} />
                  ) : (
                    <BsEyeFill color="var(--light-grey)" size={15} />
                  )
                }
                type={confirmPasswordVisible ? "password" : "text"}
                onRightIconPress={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <SubmitButton
                title={"Submit"}
                onClick={onPressSave}
                btnClass={styles.submitBtn}
              />
            </Col>
          </Row>
        </Col>

        {role == roles.client || role == roles.coHost ? (
          <Col className={styles.leftCont}>
            {/* <img className={styles.imgCont} src={ketImg} alt="key icon" /> */}
            {changePasswordKey}
          </Col>
        ) : null}
      </Row>
    </div>
    //   <div>ChangePassword</div>
  );
};

export default ChangePassword;
